//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import { IRootScopeService } from 'angular';
import universalImageActionsRightsRequestTemplate from '@legacy-components/common/universal-image-actions/universal-image-actions-rights-request.html';

const uia = angular.module('uia');

uia.directive('universalImageActionsRightsRequest', [
  '$rootScope',
  'UniversalImageActionsRightsOptionsService',
  (
    $rootScope: IRootScopeService,
    UniversalImageActionsRightsOptionsService,
  ) => {
    return {
      restrict: 'E',
      scope: {},
      require: ['^universalImageActionsModal'],
      template: universalImageActionsRightsRequestTemplate,
      link(scope: any, element, attrs, controllers) {
        // This value supports the UIARightsOptions within the Galleries workflow
        const shouldShowRightsOptions =
          UniversalImageActionsRightsOptionsService.getShouldShowRightsOptions();

        scope.model = {
          shouldShowRightsOptions,
        };

        // This event is only fired from the universal-image-actions-rights-options-service
        // and can be removed once rights is fully ported to React
        // It supports the UIARightsOptions within the Galleries workflow
        $rootScope.$on('uia:rights-options:state-changed', (_event, value) => {
          scope.$evalAsync(() => {
            scope.model.shouldShowRightsOptions = value;
          });
        });
      },
    };
  },
]);
